module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-database-3.b693af2e.svg";